<template>
    <div>
        <head-banner title="לוחות" image-name="head_lines_decor.svg" />

        <div class="b_shop">
            <div class="container">
                <div class="shop_wrapper">
                    <div class="shop_list flex">
                        <div
                            v-for="board in boards"
                            :key="board.id"
                            class="shop_item"
                        >
                            <nuxt-link
                                :to="`/boards/${board.slug}`"
                                class="shop_block text_center"
                            >
                                <div class="block_image">
                                    <div class="image_wrapper">
                                        <picture
                                            v-full-image-path="
                                                board.featuredImage
                                            "
                                        />
                                    </div>
                                    <div class="block_title second_font">
                                        {{ board.name }}
                                    </div>
                                </div>
                            </nuxt-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { StatusCodes } from 'http-status-codes';
import HeadBanner from '@/components/elements/HeadBanner';

export default {
    components: {
        HeadBanner
    },

    async asyncData({ store: { dispatch }, error, route: { query } }) {
        try {
            const boards = await dispatch('boards/index');

            return { boards, ...query };
        } catch (err) {
            if (
                err.response &&
                err.response.status !== StatusCodes.INTERNAL_SERVER_ERROR
            ) {
                return error({ statusCode: err.response.status });
            }

            console.error(err);

            return error({ statusCode: StatusCodes.INTERNAL_SERVER_ERROR });
        }
    },

    computed: {
        ...mapGetters({
            selectedCampus: 'campuses/selectedCampus'
        })
    },

    watch: {
        selectedCampus() {
            this.fetchBoards();
        }
    },

    mounted() {
        if (this.message && ['success', 'error'].includes(this.type)) {
            this.$toasted[this.type](this.message);
        }
    },

    methods: {
        ...mapActions({
            getBoards: 'boards/index'
        }),

        async fetchBoards() {
            try {
                this.boards = await this.getBoards();
            } catch (error) {
                console.error(error);

                this.$toasted.global.error();
            }
        }
    }
};
</script>
